import {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  setSelectedUpdatePaymentType,
  handleCurrentStep,
  selectSelectedUpdatePaymentType,
  selectSelectedBanData,
  selectServerData,
  selectEpiData,
  setSelectedBansForPaymentUpdate,
} from '../DebtAndUpdatePaymentBlockSlice';
import {isSingleEligibleBanAlreadySelected} from '../utils/updatePaymentBanUtils';

export const useSelectOptionForUpdatePayment = () => {
  const dispatch = useDispatch();

  const selectedUpdatePaymentType = useSelector(selectSelectedUpdatePaymentType);
  const selectedBanData = useSelector(selectSelectedBanData);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);

  const skipBanSelectForCreditCard = useMemo(
    () => isSingleEligibleBanAlreadySelected(allBans, selectedBanData?.banNumber),
    [allBans, selectedBanData?.banNumber],
  );

  const actions = {
    setSelectedUpdatePaymentType: (value) => dispatch(setSelectedUpdatePaymentType(value)),
    goToStep: (step) => dispatch(handleCurrentStep(step)),
    setSelectedBansForPaymentUpdate: (value) => dispatch(setSelectedBansForPaymentUpdate(value)),
  };

  return {
    selectedUpdatePaymentType,
    selectedBanData,
    skipBanSelectForCreditCard,
    payingEntityLink: epiData?.payingEntityLink,
    actions,
  };
};
